import { render, staticRenderFns } from "./BannerCard.vue?vue&type=template&id=638870eb&"
import script from "./BannerCard.vue?vue&type=script&lang=js&"
export * from "./BannerCard.vue?vue&type=script&lang=js&"
import style0 from "./BannerCard.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DynamicImage: require('/opt/build/repo/storefront/components/atoms/Media/DynamicImage.vue').default,BaseHeading: require('/opt/build/repo/storefront/components/atoms/Text/BaseHeading.vue').default,RichText: require('/opt/build/repo/storefront/components/atoms/Text/RichText.vue').default,BaseCard: require('/opt/build/repo/storefront/components/atoms/Card/BaseCard.vue').default})
